const funnelName = (funnels, id) =>
  funnels.find(funnel => funnel.id === id)?.name || 'funil removido';

const stageName = (funnels, funnelId, stageId) =>
  funnels
    .find(funnel => funnel.id === funnelId)
    ?.stages?.find(stage => stage.id === stageId)?.name || 'etapa removida';

export const describeTrigger = (automation, funnels) => {
  const funnel = funnelName(funnels, automation.trigger_funnel_id);

  if (automation.trigger_type === 'stage_idle') {
    const stage = stageName(
      funnels,
      automation.trigger_funnel_id,
      automation.trigger_stage_id
    );
    const days = automation.trigger_idle_days || 0;
    return `Quando ficar ${days} dia(s) parado em ${stage} no funil ${funnel}`;
  }

  if (automation.trigger_type === 'document_attached') {
    if (!automation.trigger_stage_id) {
      return `Quando um documento for anexado no funil ${funnel}`;
    }
    const stage = stageName(
      funnels,
      automation.trigger_funnel_id,
      automation.trigger_stage_id
    );
    return `Quando um documento for anexado em ${stage} no funil ${funnel}`;
  }

  if (automation.trigger_type === 'entered_stage') {
    const stage = stageName(
      funnels,
      automation.trigger_funnel_id,
      automation.trigger_stage_id
    );
    return `Quando entrar em ${stage} no funil ${funnel}`;
  }

  const outcome = automation.trigger_status === 'won' ? 'ganho' : 'perdido';
  return `Quando for marcado como ${outcome} no funil ${funnel}`;
};

const COPY_LABELS = {
  value_and_products: 'valor e produtos',
  installments_and_payment: 'parcelas e pagamento',
  open_tasks: 'tarefas',
};

const describeCopy = copy => {
  const parts = Object.keys(COPY_LABELS).filter(key => copy?.[key]);
  return parts.length
    ? ` (${parts.map(key => COPY_LABELS[key]).join(', ')})`
    : '';
};

const CONDITION_LABELS = {
  value: 'valor',
  origin: 'origem',
  assignee: 'responsável',
  conversation_label: 'etiqueta',
};

const OPERATOR_LABELS = {
  greater_than: 'maior que',
  less_than: 'menor que',
  equals: 'é',
  not_equals: 'não é',
  is_blank: 'está vazio',
  contains: 'contém',
};

// Resumo curto das condições, pra lista mostrar por que a regra às vezes não
// dispara sem precisar abrir o editor.
export const describeConditions = conditions =>
  (conditions || []).map(condition => {
    const field = CONDITION_LABELS[condition.field] || condition.field;
    const operator = OPERATOR_LABELS[condition.operator] || condition.operator;
    if (condition.operator === 'is_blank') return `${field} ${operator}`;
    return `${field} ${operator} ${condition.value ?? ''}`.trim();
  });

export const describeActions = (actions, funnels) =>
  (actions || []).map(action => {
    switch (action.type) {
      case 'move':
        return `Move para ${funnelName(funnels, action.target_funnel_id)}`;
      case 'duplicate':
        return `Duplica para ${funnelName(funnels, action.target_funnel_id)}${describeCopy(action.copy)}`;
      case 'create_task':
        return `Cria tarefa: ${action.title || 'sem título'}`;
      case 'notify':
        return 'Notifica';
      case 'send_template':
        return `Envia template: ${action.template_name || 'sem template'}`;
      case 'webhook':
        return 'Chama webhook';
      default:
        return action.type;
    }
  });
